import React, { createContext, useContext, useState } from "react";

const RefreshContext = createContext();

export const useRefresh = () => {
  const context = useContext(RefreshContext);
  if (!context) {
    throw new Error("useRefresh must be used within a RefreshProvider");
  }
  return context;
};

export const RefreshProvider = ({ children }) => {
  const [refreshTrigger, setRefreshTrigger] = useState(0);
  const [isRefreshing, setIsRefreshing] = useState(false);

  const triggerRefresh = () => {
    setRefreshTrigger(Date.now()); // Use timestamp instead of increment
  };

  const setRefreshState = state => {
    setIsRefreshing(state);
  };

  const resetTrigger = () => {
    setRefreshTrigger(0);
  };

  return (
    <RefreshContext.Provider
      value={{
        refreshTrigger,
        triggerRefresh,
        resetTrigger,
        isRefreshing,
        setRefreshState
      }}
    >
      {children}
    </RefreshContext.Provider>
  );
};
